import React from 'react';
import styles from './WidgetItem.module.scss';
import { SFText } from 'sfui';

export interface WidgetItemProps {
  className?: string;
  title: string;
  value: string;
  isLastItem?: boolean;
}

export const WidgetItem = (
  props: WidgetItemProps
): React.ReactElement<WidgetItemProps> => {
  return (
    <div
      className={`${styles.widgetItem} ${props.className} ${props.isLastItem ? styles.lastItem : ''}`}
    >
      <SFText type="component-messages" className={styles.title}>
        {props.title}
      </SFText>
      <h3 className={styles.value}>{props.value}</h3>
    </div>
  );
};
